"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const images_1 = require("../../services/images");
const react_i18next_1 = require("react-i18next");
const moment_1 = __importDefault(require("moment/moment"));
const utils_1 = require("../../services/utils");
const RequestTimeLineRowWeb_1 = __importDefault(require("./request_details/RequestTimeLineRowWeb"));
const RequestOverviewWeb = ({ flightData, asAPilot = false, navigate }) => {
    if (!flightData)
        return null;
    const [t] = (0, react_i18next_1.useTranslation)("i18n");
    const renderCityRow = () => {
        const departureDate = (0, moment_1.default)(flightData.departure_datetime).format('DD.MM.YYYY');
        return ((0, jsx_runtime_1.jsxs)("div", { className: "city-row", children: [(0, jsx_runtime_1.jsx)("span", { className: "big-detail", children: flightData.departure_from.city }), (0, jsx_runtime_1.jsx)("span", { className: asAPilot ? "text-bold" : "text-detail", children: departureDate }), (0, jsx_runtime_1.jsx)("span", { className: "big-detail", children: flightData.destination_to.city })] }));
    };
    const renderPassengersDetail = () => {
        const count = (0, utils_1.calculatePassengersCount)(flightData.passengers_seats);
        const text = `${count} ${t(count === 1 ? "overview.passenger" : "overview.passengers")}`;
        return ((0, jsx_runtime_1.jsxs)("div", { className: "detail", children: [(0, jsx_runtime_1.jsx)("img", { src: images_1.icons.DedicatedDetail, alt: "" }), (0, jsx_runtime_1.jsx)("span", { className: "text-detail", children: text })] }));
    };
    return ((0, jsx_runtime_1.jsxs)("div", { className: "flight-card-container flight-details", onClick: () => navigate(), children: [renderCityRow(), (0, jsx_runtime_1.jsx)(RequestTimeLineRowWeb_1.default, { showDetails: !asAPilot }), (0, jsx_runtime_1.jsx)("div", { className: "details-row", children: renderPassengersDetail() })] }));
};
exports.default = RequestOverviewWeb;
